import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Line } from "@ant-design/plots";

const Overview1 = () => {
  const data = [
    {
      Date: "2010-01",
      scales: 0,
    },
    {
      Date: "2010-02",
      scales: 10,
    },
    {
      Date: "2010-03",
      scales: 10,
    },
    {
      Date: "2010-04",
      scales: 15,
    },
    {
      Date: "2010-05",
      scales: 20,
    },
    {
      Date: "2010-06",
      scales: 20,
    },
    {
      Date: "2010-07",
      scales: 25,
    },
    {
      Date: "2010-08",
      scales: 25,
    },
    {
      Date: "2010-09",
      scales: 25,
    },
    {
      Date: "2010-10",
      scales: 30,
    },
    {
      Date: "2010-11",
      scales: 30,
    },
    {
      Date: "2010-12",
      scales: 35,
    },
    {
      Date: "2011-01",
      scales: 40,
    },
    {
      Date: "2011-02",
      scales: 40,
    },
    {
      Date: "2011-03",
      scales: 40,
    },
    {
      Date: "2011-04",
      scales: 40,
    },
    {
      Date: "2011-05",
      scales: 45,
    },
    {
      Date: "2011-06",
      scales: 45,
    },
    {
      Date: "2011-07",
      scales: 50,
    },
    {
      Date: "2011-08",
      scales: 50,
    },
    {
      Date: "2011-09",
      scales: 55,
    },
    {
      Date: "2011-10",
      scales: 60,
    },
    {
      Date: "2011-11",
      scales: 65,
    },
    {
      Date: "2011-12",
      scales: 65,
    },
    {
      Date: "2012-01",
      scales: 65,
    },
    {
      Date: "2012-02",
      scales: 70,
    },
    {
      Date: "2012-03",
      scales: 70,
    },
    {
      Date: "2012-04",
      scales: 75,
    },
  ];

  const config = {
    data,
    height: 150,
    padding: "auto",
    xField: "Date",
    yField: "scales",
    xAxis: {
      tickCount: 5,
    },
    yAxis: {
      maxLimit: 100,
    },
  };

  return <Line {...config} />;
};

export default Overview1;
